import React from "react";
import CurrencyConverter from "utils/CurrencyConverter";
import "./AppliedFilters.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";
import { filtersAtomObject } from "../../state";

const AppliedFilters = ({ clearFilter }) => {
  const [filters] = useAtom(filtersAtomObject);

  const handleClearTypeFilter = (type, key) => {
    clearFilter && clearFilter(type, key);
  };
  const { t } = useTranslation();
  return (
    <>
      <div className="applied-filters">
        {filters.remoteWorking === true && (
          <span className="applied-filter">
            {t("remote_working")}
            <FontAwesomeIcon
              className="close-button"
              icon={faXmark}
              onClick={() => handleClearTypeFilter("remote")}
            />
          </span>
        )}

        {filters.commute &&
          filters.commute.method &&
          filters.commute.method.id > 0 && (
            <span className="applied-filter">
              {t("number_of_minutes_by_commute_method_from_location_text").replace("(NUMBER_OF_MINUTES)", filters.commute.travelTime).replace("(COMMUTE_METHOD)", filters.commute.method.name).replace("(LOCATION_TEXT)", filters.commute.startingLocation.name)}
              <FontAwesomeIcon
                className="close-button"
                icon={faXmark}
                onClick={() => handleClearTypeFilter("commute")}
              />
            </span>
          )}

        {filters.queryString && (
          <span className="applied-filter">
            {filters.queryString}
            <FontAwesomeIcon
              className="close-button"
              icon={faXmark}
              onClick={() => handleClearTypeFilter("queryString")}
            />
          </span>
        )}

        {filters.location && (
          <span className="applied-filter">
            {t("within")}{' '}{filters.distance}{' '}{t("miles")}{' '}{t("of")}{' '}{filters.location}{" "}
            <FontAwesomeIcon
              className="close-button"
              icon={faXmark}
              onClick={() => handleClearTypeFilter("location")}
            />
          </span>
        )}

        {filters.jobTypes &&
          filters.jobTypes.map((item, index) => (
            <span className="applied-filter" key={index}>
              {item?.display}
              <FontAwesomeIcon
                className="close-button"
                icon={faXmark}
                onClick={() => handleClearTypeFilter("type", item.key)}
              />
            </span>
          ))}

        {Array.from({ length: 4 }, (_, i) => i + 1).map(
          (i) =>
            filters[`customStringAttributes${i}`] &&
            filters[`customStringAttributes${i}`]?.map(
              (customStringAttribute, index) => (
                <span className="applied-filter" key={index}>
                  {customStringAttribute.display ?? customStringAttribute.name}
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="close-button"
                    onClick={() =>
                      handleClearTypeFilter(
                        `customStringAttributes${i}`,
                        customStringAttribute.id
                      )
                    }
                  />
                </span>
              )
            )
        )}

        {filters.customStringAttributes &&
          filters.customStringAttributes.map((sector, index) => (
            <span className="applied-filter" key={index}>
              {sector?.name}
              <FontAwesomeIcon
                className="close-button"
                icon={faXmark}
                onClick={() => handleClearTypeFilter("sector", sector.id)}
              />
            </span>
          ))}

        {filters.salary && filters.salary.minimum && (
          <span className="applied-filter">
            {" "}
            <CurrencyConverter
              value={filters.salary.minimum}
              currency={filters.salary.currencyCode}
            />
            &nbsp;
            {filters.salary.type?.name}
            <FontAwesomeIcon
              className="close-button"
              icon={faXmark}
              onClick={() => handleClearTypeFilter("salary")}
            />
          </span>
        )}
      </div>
    </>
  );
};

export default AppliedFilters;
